import React from "react";

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { Cancel, Close } from "@material-ui/icons";

const DialogPage = (props) => {
  return (
    <div>
      <Dialog
        open={props.open}
        // TransitionComponent={fade}
        keepMounted
        // onClose={props.handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          <p style={{ fontSize: 26, fontWeight: 800, display:"flex", justifyContent:"space-between", marginTop:"0px" }}>Confirmation! <Close onClick={props.handleClose} /></p>
          <span> </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="black" id="alert-dialog-slide-description">
            Are you sure you want to change the Payment Validation of
            <span className="font-extrabold capitalize"> {props.name} </span>to{" "}
            <span className="font-extrabold"> {props.status} </span>?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{color:"#256141"}}>
          <Button variant="outlined" onClick={props.handleClose} style={{color:"#256141", fontWeight:800, width:"100px"}}>
            Cancel
          </Button>
          {props.loading ? (
            <CircularProgress style={{marginRight:"10px"}} />
          ) : (
            <Button variant="contained" onClick={props.handleSubmit} style={{width:"100px",color:"white", backgroundColor:"#256141", fontWeight:800}}>
              Yes
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogPage;
